import React, { useState } from "react";
import Modal from "../common/Modal";
import SearchableLocationDropdown from "../common/SearchableLocationDropdown";

const LocationSelector = () => {
    const [open, setOpen] = useState(false);
    const [location, setLocation] = useState("Ahmedabad Warehouse");

    return (
        <div className="card mb-4 shadow-sm border">

            {/* Header */}
            <div className="d-flex justify-content-between align-items-center w-100">
                <div>
                    <strong className="text-secondary" style={{ fontSize: "14px" }}>
                        Material Location
                    </strong>
                    <p className="mb-0 mt-1 fw-semibold" style={{ fontSize: "16px", color: "#111" }}>
                        {location}
                    </p>
                </div>

                <button
                    className="btn btn-primary btn-sm"
                    onClick={() => setOpen(true)}
                >
                    Change
                </button>
            </div>

            {/* Modal */}
            <Modal open={open} title="Select Location" onClose={() => setOpen(false)}>

                <SearchableLocationDropdown
                    onSelect={(loc) => {
                        setLocation(loc);
                        setOpen(false);
                    }}
                />

                {/* Saved Addresses */}
                <div className="mt-4">
                    <h4 style={{ fontSize: "14px" }} className="mb-2">
                        Saved Addresses
                    </h4>

                    <div>
                        <div className="p-2 border rounded mb-2 cursor-pointer">
                            Mumbai Yard
                        </div>
                        <div className="p-2 border rounded mb-2 cursor-pointer">
                            Delhi Warehouse
                        </div>
                    </div>
                </div>

                {/* Button */}
                <button className="btn btn-primary w-100 mt-3">
                    Use Current Location
                </button>

            </Modal>

        </div>
    );
};

export default LocationSelector;